import React, {Fragment} from 'react';
import {connect} from "react-redux";
import ReactLoading from 'react-loading';
import {fetchPayoutInfo} from "../actions/payouts";
import {FormattedDate, FormattedPrice} from "clorian-frontend-components";
import Cookie from "js-cookie";


class PayoutBreakdownInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            affiliateReturnVoList: null
        }
    }

    componentDidMount() {
        const {dispatch, payoutId} = this.props;
        dispatch(fetchPayoutInfo(payoutId)).then(({response}) => {
            if(response)
                this.setState({ affiliateReturnVoList: response.affiliateReturnVoList });
        });
    }

    render() {

        const {affiliateReturnVoList} = this.state;
        const {colspan, currency} = this.props;
        const locale = Cookie.get('locale') || 'en';

        const html = affiliateReturnVoList === null ? <tr>
            <td/>
            <td>
                <div className="loader">
                    <ReactLoading color="gray" type="bubbles" height="40px" width="40px"/>
                </div>
            </td>
        </tr> : this.generateHtml(affiliateReturnVoList, colspan, currency, locale);
        return <Fragment> {html} </Fragment>;
    }


    generateHtml(affiliateReturnVoList, colspan, currency, locale) {

        return (<Fragment>
            {
                affiliateReturnVoList.map(r => {
                    return (
                        <tr className="level2" key={r.returnId}>
                            <td><span className="icon-own-forward-b"></span></td>
                            <td colSpan={colspan} className="payoutReturnBreakdown">
                                <span className="returnLabel">Return Id: </span>
                                <span>{r.returnId}</span>
                                <br/>
                                <span className="returnLabel">Creation Date: </span>
                                <FormattedDate value={r.creationDate}/>
                                <br/>
                                <span className="returnLabel">Value: </span>
                                <FormattedPrice value={r.returnValue} currency={currency} locale={locale}/>
                                <br/>
                                {r.reservationVoList.map(res => {
                                    return (
                                        <Fragment>
                                            <span className="returnLabel">Reservation Number - </span>
                                            <span>{res.reservationId}</span>
                                            <br/>
                                            {res.ticketSet.map( (t, i) => {
                                                return (
                                                    <Fragment>
                                                        {i === 0 ? <Fragment><span className="returnLabel" style={{marginLeft: "10px"}}>Ticket Ids: </span><br/></Fragment> : null}
                                                        <span style={{marginLeft: "10px"}} >{t.ticketId}</span><br/>
                                                    </Fragment>
                                                );
                                            })}
                                        </Fragment>
                                    );
                                })}
                            </td>
                        </tr>)
                })
            }
        </Fragment>)
    }


}

const mapStateToProps = state => {
    const {clients, affiliates} = state;
    const {clientList} = clients;
    let clientIndex = clientList.findIndex(el => el.clientId === affiliates.currentAffiliate.clientId);
    const sCurrency = clientIndex !== -1 ? clientList[clientIndex].currencyList[0].isoCode : 'EUR';
    return {
        currency: sCurrency
    }
}
export default connect(mapStateToProps)(PayoutBreakdownInfo);